import { createServerFn } from '@tanstack/react-start';
import { z } from 'zod';
import { requireStaff } from '@generated/server/staff.server';

export const SCENE_FLAG_URL = 'http://gbrook8344s-team-company.monday.com/generated_static/35711259/e7525548-33cf-43c6-8e4f-3b660fd06bfa.png';

/** Fetches the Scene flag artwork server-side and returns it as a data URL, so the browser can
 *  draw it on a canvas and export it (a cross-site image would otherwise block the download). */
export const getSceneFlagArt = createServerFn({ method: 'POST' })
  .validator(z.object({ pass: z.string().optional() }))
  .handler(async ({ data }) => {
    await requireStaff(data.pass);
    const urls = [SCENE_FLAG_URL.replace(/^http:/, 'https:'), SCENE_FLAG_URL];
    for (const url of urls) {
      try {
        const res = await fetch(url);
        if (!res.ok) continue;
        const type = res.headers.get('content-type') || 'image/png';
        const bytes = new Uint8Array(await res.arrayBuffer());
        let bin = '';
        for (let i = 0; i < bytes.length; i += 0x8000) bin += String.fromCharCode(...bytes.subarray(i, i + 0x8000));
        const b64 = btoa(bin);
        return { dataUrl: `data:${type};base64,${b64}`, source: SCENE_FLAG_URL };
      } catch (e) { console.error('[sceneFlag] fetch failed', url, e); }
    }
    throw new Error('The Scene flag artwork could not be loaded.');
  });
